<div class="row pl-5 pt-5">
<div class="col-md-4">
<div class="container send-money" style="padding:5%;">
    <h3 class="sm-6 purpose-heding"> Transfer purpose</h3>
    <small class="custom-text-font-purpose text-secondary ">When sending money, we have to ask the reason for your transfer. Please select yours from below.</small>
   

<div  class="md-6 sm-12 mt-2" >
    <form #purposeForm="ngForm" (ngSubmit)="onpurposeFormSubmit(purposeForm)">
    <div class="form-group">
        
                   
        <select class="form-control" name="remittance_purpose" ngModel>
            <option value="" hidden> --Select-- </option>
            <option value="Land Purchase"> Land Purchase </option>
            <option value="House Purchase"> House Purchase </option>
            <option value="House Building"> House Building </option>
            <option value="Loan Repayment"> Loan Repayment </option>
            <option value="Education Expense"> Education Expense </option>
            <option value="Medical Expenses"> Medical Expenses </option>
            <option value="Family Expenses"> Family Expenses </option>
            <option value="Savings Deposits"> Savings Deposits </option>
            <option value="Marriage Expenses"> Marriage Expenses </option>
            <option value="Travelling Expenses"> Travelling Expenses </option>
            <option value="Gifts"> Gifts </option>
        </select>
             
    </div>
    <div>
    <label for="description">Description</label>
        <span style="color:red;">*</span>
        <textarea class="form-control p-3" rows="8"  required name="note" ngModel
            placeholder="Payment Description"></textarea>   
            </div>

        <button type="button" class="btn primary-btn">Back</button>
        <button type="submit" class="btn primary-btn ml-2">Next</button>
        

    </form>
    </div>
</div>
</div>
</div>